import * as React from "react";

const STORAGE_KEY = "PaxPlan";

const DEFAULT_PAX_DATA = {
  adults: 1,
  children: 0,
  agesChildren: [],
};

const usePaxPlan = () => {
  const [paxPlan, _setPaxPlan] = React.useState(DEFAULT_PAX_DATA);

  const setPaxPlan = (newPaxPlan) => {
    if (
      (newPaxPlan && newPaxPlan.adults + newPaxPlan.children === 0) ||
      !newPaxPlan
    ) {
      _setPaxPlan(undefined);
      window.sessionStorage.removeItem(STORAGE_KEY);
    } else if (newPaxPlan) {
      _setPaxPlan(newPaxPlan);
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(newPaxPlan));
    }
  };

  React.useEffect(() => {
    const storedPax = window.sessionStorage.getItem(STORAGE_KEY);
    setPaxPlan(storedPax ? JSON.parse(storedPax) : DEFAULT_PAX_DATA);
  }, []);

  return [paxPlan, setPaxPlan];
};

export default usePaxPlan;
